import classNames from 'classnames'

import * as styles from './Divider.module.css'

function Divider({ className = styles.Divider, style }) {
  // Get modifier class from CSS Modules by `style` key.
  // If style is not provided or invalid, returns null (no extra class applied).
  const modifierClass = styles[style] || null

  return <div className={classNames(className, modifierClass)} />
}

export default Divider
